import * as React from "react";

import { Account } from "@/types";
import { RequestDetailsField } from "@/components/molecules";
import { ViewMoreContainer } from "@/components/molecules";
import { PayeeDetails, PaymentMethod } from "../PayeeDetails";
import { NotAvailable } from "./NotAvailable";
import { readableAccountNextSteps } from "@/utils/accounts";


export const InsuranceAccountDetails: React.FC<{ account: Account }> = ({ account }) => {
  return (
    <>
      <RequestDetailsField label="Notifier request">
        {readableAccountNextSteps(account.nextSteps, account.serviceProvider?.serviceProviderType)}
      </RequestDetailsField>
      <RequestDetailsField label="Policy number">
        {account.accountNumber || <NotAvailable />}
      </RequestDetailsField>
      <RequestDetailsField label="Customer reference number">
        {account.holderNumber || <NotAvailable />}
      </RequestDetailsField>
      <RequestDetailsField label="Joint policy">
        {account.jointClaim ? "Yes" : "No"}
      </RequestDetailsField>
      <ViewMoreContainer>
        <PayeeDetails paymentMethod={PaymentMethod.BankTransfer} account={account} />
      </ViewMoreContainer>
    </>
  );
};
